import React, { useState } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { SearchBarWrapper, SearchBarInputWrapper, ExploreSearchButton } from './index.styled';

interface SearchBarProp {
  defaultValue?: string;
  onSubmit?: (value: string) => void;
}

const SearchBar = ({ defaultValue, onSubmit }: SearchBarProp) => {
  const [inputValue, setInputValue] = useState(defaultValue);

  return (
    <SearchBarWrapper>
      <SearchBarInputWrapper>
        <i className="icon-search" />
        <Input
          onChange={(e) => setInputValue(e.target.value)}
          value={inputValue}
          placeholder="Search"
          onPressEnter={() => onSubmit?.(inputValue ?? '')}
        />
      </SearchBarInputWrapper>
      <ExploreSearchButton
        htmlType="button"
        type="default"
        onClick={() => {
          if (onSubmit) {
            onSubmit(inputValue ?? '');
          }
        }}
      >
        <SearchOutlined />
        Search
      </ExploreSearchButton>
    </SearchBarWrapper>
  );
};

export default SearchBar;
